import { render, staticRenderFns } from "./EventCardList.vue?vue&type=template&id=c4a0f4f6&"
import script from "./EventCardList.vue?vue&type=script&lang=ts&"
export * from "./EventCardList.vue?vue&type=script&lang=ts&"
import style0 from "./EventCardList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports